import React from 'react';

import Alert from '@material-ui/lab/Alert';

import { growthStagesTypes } from '../../../_constants/growthsConstants';
import LoadingIndicator from '../../../Components/LoadingIndicator';
import {
  ContentBody,
  ContentContainer,
  ContentHeader,
  ResponsiveHeaderButtonsContainer
} from '../../../Layout/Content';

import { useGrowthModelReportWithDistricts } from './_hooks/useGrowthModelReportWithDistricts';
import { useReportsChartsControls } from './_hooks/useReportsChartsControls';
import GrowthModelReportTable from './GrowthModelReportTable';
import HarvestReportChart from './HarvestReportChart';
import ReportsDataGridWrapper from './ReportsDataGridWrapper';
import TableChartToggle from './TableChartToggle';

const reportGrowthStages = [growthStagesTypes.Harvest];

const HarvestReport = () => {
  const { inProgress, errorMessage, response } =
    useGrowthModelReportWithDistricts();

  const { showChart, toggleChart, visibleRows, handleVisibleRowIdsChange } =
    useReportsChartsControls(response);

  return (
    <ContentContainer>
      <ContentHeader>
        <span>Harvest Report</span>
        <ResponsiveHeaderButtonsContainer>
          <TableChartToggle showChart={showChart} onToggle={toggleChart} />
        </ResponsiveHeaderButtonsContainer>
      </ContentHeader>
      <ContentBody>
        {inProgress && <LoadingIndicator />}
        {!inProgress && errorMessage && (
          <Alert severity="error">{errorMessage}</Alert>
        )}
        {!inProgress && !errorMessage && (
          <>
            <ReportsDataGridWrapper hide={showChart}>
              <GrowthModelReportTable
                reportGrowthStages={reportGrowthStages}
                growthModelReportResponse={response}
                onVisibleRowIdsChange={handleVisibleRowIdsChange}
              />
            </ReportsDataGridWrapper>
            {showChart && <HarvestReportChart fields={visibleRows} />}
          </>
        )}
      </ContentBody>
    </ContentContainer>
  );
};

export default HarvestReport;
